import obvmConfig from '../config';

// MaterialUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function LastUpdate() {
	return (
	  <Typography variant="body2" color="text.secondary" align="center">
		{'Last refreshed: '}{new Date().toLocaleString()}
	  </Typography>
	);
}

function Copyright() {
	return (
	  <Typography variant="body2" color="text.secondary" align="center">
		{'Copyright © '}
		<Link color="inherit" href="https://www.btechinc.com/">
		  BTECH, Inc.
		</Link>
		{' '}{obvmConfig.APP.COPYRIGHT_YEAR}
		{' - OBVM Version '}{obvmConfig.APP.VERSION}
		{' ('}{obvmConfig.APP.VERSION_DATE}{')'}
	  </Typography>
	);
}

export default function Footer() {
	return (
		<Box component="footer" sx={{ pb: 2, pt: 1, bgcolor: '#D8D7D6' }}>
			{/* <LastUpdate /> */}
			<Copyright />
		</Box>
	);
}